(() => {
  'use strict';

  if (window.__STRYKR_KACHING_ATC_20260427__) return;
  window.__STRYKR_KACHING_ATC_20260427__ = true;

  const BUTTON_SELECTOR = '[data-strykr-kaching-atc], #cta-main, [id^="ProductSubmitButton-"]';
  const BUTTON_CLASS = 'strykr-kaching-atc-button';

  const ready = (callback) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  };

  const isFrenchLocale = /^\/fr(?:[-/]|$)/.test(window.location.pathname);
  const buttonStrings = isFrenchLocale
    ? {
        addToCart: 'Ajouter au panier',
        adding: 'Ajout en cours...',
        added: 'Ajouté au panier',
        error: 'Erreur · réessayez'
      }
    : {
        addToCart: 'Jetzt in den Warenkorb',
        adding: 'Wird hinzugefügt...',
        added: 'Hinzugefügt ✓',
        error: 'Fehler · erneut versuchen'
      };
  const getPdpStrings = () => {
    const payload = window.STRYKR_PRODUCT || window.STRYKR_PDP;
    return payload && payload.strings ? payload.strings : null;
  };
  const getButtonString = (key) => {
    const source = getPdpStrings();
    const value = source && source[key] ? source[key] : '';
    if (!isFrenchLocale) return value || buttonStrings[key] || '';
    if (!value || ['Jetzt in den Warenkorb', 'Wird hinzugefügt...', 'Wird hinzugefügt…', 'Hinzugefügt ✓', 'Hinzugefügt', 'Fehler · erneut versuchen'].includes(value)) {
      return buttonStrings[key] || '';
    }
    return value;
  };

  const rootPath = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const normalize = (value) => String(value || '').trim().toLowerCase();
  const parseJson = (value, fallback = null) => {
    try {
      return JSON.parse(value || 'null') || fallback;
    } catch (_) {
      return fallback;
    }
  };
  const parseAttr = (node, attr, fallback = null) => node ? parseJson(node.getAttribute(attr), fallback) : fallback;

  const findScope = (node) => {
    if (node && node.closest) {
      return node.closest('[data-strykr-main-product], section[id^="MainProduct-"], product-info, .main-product__info-container, .product__info-container') || document;
    }
    return document;
  };

  const findKachingBlock = (scope = document) => {
    return scope.querySelector('kaching-bundles-block') || document.querySelector('kaching-bundles-block');
  };

  const findKachingZone = (scope = document) => {
    return scope.querySelector('#strykr-pricing-zone, .kaching-mount, kaching-bundle, kaching-bundles-block')
      || document.querySelector('#strykr-pricing-zone, .kaching-mount, kaching-bundle, kaching-bundles-block');
  };

  const getKachingProduct = (block) => {
    const blockProduct = parseAttr(block, 'product');
    if (blockProduct) return blockProduct;

    const productId = block && (block.getAttribute('product-id') || parseJson(block.getAttribute('config'), {})?.productId);
    const script = productId
      ? document.querySelector(`script.kaching-bundles-product[data-product-id="${CSS.escape(String(productId))}"]`)
      : document.querySelector('script.kaching-bundles-product[data-main="true"], script.kaching-bundles-product[data-product-id]');
    return parseJson(script && script.textContent, {}) || {};
  };

  const getDealBlock = (block) => parseAttr(block, 'deal-block', {}) || {};

  const getSelectedDeal = (scope, block) => {
    const dealBlock = getDealBlock(block);
    const checked = (scope || document).querySelector('input[type="radio"][name^="kaching-bundles-deal"]:checked')
      || document.querySelector('input[type="radio"][name^="kaching-bundles-deal"]:checked');
    const selectedId = checked && checked.value ? checked.value : dealBlock.preselectedDealBarId;
    if (!selectedId || !Array.isArray(dealBlock.dealBars)) return null;
    return dealBlock.dealBars.find((deal) => String(deal.id) === String(selectedId)) || null;
  };

  const getSelectedOptions = (scope, product) => {
    const optionNames = Array.isArray(product.options)
      ? product.options.map((option) => option && (option.name || option.defaultName)).filter(Boolean)
      : [];
    const selects = Array.from((scope || document).querySelectorAll('select.kaching-bundles-option, .kaching-bundles__bar-variant-select'));
    if (!selects.length) return [];

    if (optionNames.length) {
      const byName = new Map();
      selects.forEach((select) => {
        const name = select.dataset && select.dataset.name;
        if (!name) return;
        const key = normalize(name);
        if (!byName.has(key)) byName.set(key, select.value);
      });
      const ordered = optionNames.map((name) => byName.get(normalize(name)));
      if (ordered.every(Boolean)) return ordered;
    }

    return selects.slice(0, optionNames.length || selects.length).map((select) => select.value).filter(Boolean);
  };

  const findVariant = (scope, product) => {
    const selectedOptions = getSelectedOptions(scope, product);
    const variants = Array.isArray(product.variants) ? product.variants : [];

    if (selectedOptions.length) {
      const matched = variants.find((candidate) => {
        const options = Array.isArray(candidate.options) ? candidate.options : [];
        return selectedOptions.every((option, index) => normalize(options[index]) === normalize(option));
      });
      if (matched && matched.id) return matched;
    }

    const selectedId = product.selectedVariantId || product.selected_variant_id;
    return variants.find((candidate) => String(candidate.id) === String(selectedId))
      || variants.find((candidate) => candidate.availableForSale !== false && candidate.available !== false)
      || variants[0]
      || null;
  };

  const findExistingProperty = (scope, name) => {
    const escaped = CSS.escape(`properties[${name}]`);
    const input = (scope || document).querySelector(`input[name="${escaped}"]`) || document.querySelector(`input[name="${escaped}"]`);
    return input && input.value ? input.value : '';
  };

  const buildKachingProperties = (scope, block, selectedDeal) => {
    const existingBundle = findExistingProperty(scope, '__kaching_bundles');
    const existingSession = findExistingProperty(scope, '__kaching_session_id');
    if (existingBundle && existingSession) {
      return {
        __kaching_bundles: existingBundle,
        __kaching_session_id: existingSession
      };
    }

    const dealBlock = getDealBlock(block);
    const bundleValue = JSON.stringify({
      deal: dealBlock.nanoId || dealBlock.id || (block && block.getAttribute('deal-block-id')) || '',
      main: true,
      bid: selectedDeal && selectedDeal.id ? selectedDeal.id : dealBlock.preselectedDealBarId || '',
      ab: dealBlock.abTestVariantNumber === 2 ? 'B' : 'A'
    });

    return {
      __kaching_bundles: bundleValue,
      __kaching_session_id: existingSession || (
        window.crypto && typeof window.crypto.randomUUID === 'function'
          ? window.crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(16).slice(2)}`
      )
    };
  };

  const buildPayload = (button) => {
    const scope = findScope(button);
    const block = findKachingBlock(scope);
    const product = getKachingProduct(block);
    const selectedDeal = getSelectedDeal(scope, block);
    const variant = findVariant(scope, product);
    const quantity = Number(selectedDeal && selectedDeal.quantity) || 1;

    if (!variant || !variant.id) {
      throw new Error('Variante introuvable depuis Kaching.');
    }

    const properties = buildKachingProperties(scope, block, selectedDeal);
    const item = {
      id: Number(variant.id),
      quantity,
      properties
    };

    return { items: [item] };
  };

  const isolatedCartAdd = async (payload) => {
    const frame = document.createElement('iframe');
    frame.setAttribute('aria-hidden', 'true');
    frame.tabIndex = -1;
    frame.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden;';
    document.body.appendChild(frame);

    try {
      const nativeFetch = frame.contentWindow.fetch.bind(frame.contentWindow);
      const response = await nativeFetch(`${rootPath()}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      });
      const text = await response.text();
      const json = text ? JSON.parse(text) : {};
      if (!response.ok) throw new Error(json.description || json.message || response.statusText);
      return json;
    } finally {
      frame.remove();
    }
  };

  const ensureDrawerElement = () => {
    if (typeof window.removeTrapFocus !== 'function') window.removeTrapFocus = () => {};
    if (typeof window.trapFocus !== 'function') window.trapFocus = () => {};
    if (!window.customElements || window.customElements.get('cart-drawer')) return;

    window.customElements.define('cart-drawer', class CartDrawer extends HTMLElement {
      connectedCallback() {
        const overlay = this.querySelector('#CartDrawer-Overlay, .cart-drawer__overlay');
        if (overlay && overlay.dataset.strykrDrawerBound !== 'true') {
          overlay.dataset.strykrDrawerBound = 'true';
          overlay.addEventListener('click', () => this.close());
        }
      }

      open() {
        this.classList.add('active');
        this.classList.remove('is-empty');
        document.body.classList.add('overflow-hidden');
      }

      close() {
        this.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      }
    });
  };

  const sectionUrl = (ids) => {
    const url = new URL(rootPath(), window.location.origin);
    url.searchParams.set('sections', ids.join(','));
    return url.toString();
  };

  const replaceSection = (id, html) => {
    if (!html) return;
    const current = document.getElementById(`shopify-section-${id}`);
    const next = new DOMParser().parseFromString(html, 'text/html').getElementById(`shopify-section-${id}`);
    if (current && next) current.innerHTML = next.innerHTML;
  };

  const refreshDrawer = async () => {
    try {
      const response = await fetch(sectionUrl(['cart-drawer', 'cart-icon-bubble']), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) return;
      const sections = await response.json();
      replaceSection('cart-drawer', sections['cart-drawer']);
      replaceSection('cart-icon-bubble', sections['cart-icon-bubble']);
    } catch (_) {}
  };

  const openDrawer = async () => {
    ensureDrawerElement();
    await refreshDrawer();
    ensureDrawerElement();
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    if (drawer) {
      drawer.classList.add('active');
      drawer.classList.remove('is-empty');
      document.body.classList.add('overflow-hidden');
    }
  };

  const updateCartCount = async () => {
    try {
      const cart = await fetch(`${rootPath()}cart.js`, { headers: { Accept: 'application/json' } }).then((response) => response.json());
      document.querySelectorAll('[data-cart-count], .cart-count-bubble span, #cart-count').forEach((node) => {
        node.textContent = String(cart.item_count);
      });
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart } }));
      return cart;
    } catch (_) {
      return null;
    }
  };

  const setButtonState = (button, state) => {
    if (!button) return;
    const text = button.querySelector('[data-cta-text], .main-atc__label__text, .button__label') || button;
    if (!button.dataset.defaultText) button.dataset.defaultText = text.textContent.trim() || 'Jetzt in den Warenkorb';

    if (state === 'loading') {
      button.disabled = true;
      text.textContent = 'Wird hinzugefügt...';
    } else if (state === 'added') {
      text.textContent = 'Hinzugefügt ✓';
    } else if (state === 'error') {
      text.textContent = 'Fehler · erneut versuchen';
    } else {
      button.disabled = false;
      text.textContent = button.dataset.defaultText || 'Jetzt in den Warenkorb';
    }
  };

  const addToCart = async (button) => {
    if (!button || button.dataset.strykrAdding === 'true') return;
    button.dataset.strykrAdding = 'true';
    setButtonState(button, 'loading');

    try {
      const payload = buildPayload(button);
      const added = await isolatedCartAdd(payload);
      document.dispatchEvent(new CustomEvent('cart:added', { detail: added }));
      await updateCartCount();
      setButtonState(button, 'added');
      await openDrawer();
      window.setTimeout(() => {
        delete button.dataset.strykrAdding;
        setButtonState(button, 'idle');
      }, 350);
    } catch (error) {
      console.warn('[STRYKR] Kaching ATC failed', error);
      setButtonState(button, 'error');
      window.setTimeout(() => {
        delete button.dataset.strykrAdding;
        setButtonState(button, 'idle');
      }, 1600);
    }
  };

  const injectStyles = () => {
    if (document.getElementById('strykr-kaching-atc-style')) return;
    const style = document.createElement('style');
    style.id = 'strykr-kaching-atc-style';
    style.textContent = `
      .${BUTTON_CLASS} {
        width: 100%;
        min-height: 58px;
        border: 0;
        border-radius: 0;
        background: #ff5a1f;
        color: #fff;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 16px 22px;
        font: inherit;
        font-weight: 800;
        letter-spacing: .12em;
        text-transform: uppercase;
        cursor: pointer;
        transition: transform .18s ease, filter .18s ease, opacity .18s ease;
      }
      .${BUTTON_CLASS}:hover { filter: brightness(.95); transform: translateY(-1px); }
      .${BUTTON_CLASS}:disabled { cursor: wait; opacity: .78; transform: none; }
    `;
    document.head.appendChild(style);
  };

  const createButton = (scope) => {
    const zone = findKachingZone(scope);
    if (!zone) return;
    const localScope = findScope(zone);
    if (localScope.querySelector('[data-strykr-kaching-atc], #cta-main')) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.dataset.strykrKachingAtc = 'true';
    button.className = `${BUTTON_CLASS} button button--full-width button--margin-x main-product-atc`;
    button.innerHTML = '<span class="button__label" data-cta-text>Jetzt in den Warenkorb</span>';

    const wrapper = document.createElement('div');
    wrapper.className = 'strykr-kaching-atc-wrapper';
    wrapper.appendChild(button);
    zone.insertAdjacentElement('afterend', wrapper);
  };

  const bind = () => {
    injectStyles();
    document.querySelectorAll('kaching-bundles-block, #strykr-pricing-zone, .kaching-mount').forEach((node) => {
      createButton(findScope(node));
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target && event.target.closest && event.target.closest(BUTTON_SELECTOR);
    if (!button) return;
    const scope = findScope(button);
    if (!findKachingBlock(scope)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addToCart(button);
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target && event.target.closest && event.target.closest('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
    if (!form) return;
    const scope = findScope(form);
    if (!findKachingBlock(scope)) return;
    const button = form.querySelector(BUTTON_SELECTOR) || scope.querySelector(BUTTON_SELECTOR);
    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addToCart(button);
  }, true);

  ready(() => {
    bind();
    const observer = new MutationObserver(bind);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  });
})();

